import { motion } from 'framer-motion';
import styled from 'styled-components';
export const Content = styled(motion.div)`
  overflow: hidden;
`;

//# sourceMappingURL=Collapsible.styles.js.map